export default __webpack_public_path__ + "static/media/Side1.0fb82059.png";